import * as tslib_1 from "tslib";
import styled from 'sinoui-components/styles';
var PopLayout = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return !props.useModal &&
        "\n  position: relative;\n  display: inline-block;\n  ";
});
export default PopLayout;
var templateObject_1;
//# sourceMappingURL=PopLayout.js.map